import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    newFolder: string;
    newRestrictedFolder: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label for creating a new sub-folder */
            newFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CreateFolderMenu.newFolder?c=hz1l49khdeht", defaultMessage: "New Folder" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for creating a new restricted sub-folder */
            newRestrictedFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CreateFolderMenu.newRestrictedFolder?c=3bkxqej52favx", defaultMessage: "New Restricted Folder" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
